import { colorConfig } from '@themes/config'

import animation from './animation'
import measures from './measures'
import spacing from './spacing'
import { ThemeType } from './types'
import typography from './typography'
import utils from './utils'
import zIndex from './zIndex'

const defaultTheme = {
  typography,
  spacing,
  animation,
  measures,
  zIndex,
  utils,
  colors: colorConfig,
} as const satisfies ThemeType<typeof colorConfig>

export default defaultTheme
